import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { list4uBusAutomations } from "../../../../../services/uBusAutomationRobot";
import { useParams } from "react-router-dom";
import FormInformation from "../../../../../components/FormInformation/FormInformation";
import { TRelationshipGroupForm } from "./relationshipGroupSchema";

interface IUBusAutomationProps {
  defineUBusAutomationCode: (code: number) => void;
  disableEdit?: boolean;
}

const translationPath = "page.4uBus.relationships.relationshipGroup.";

export const UBusAutomation = memo(
  ({ defineUBusAutomationCode, disableEdit = false }: IUBusAutomationProps) => {
    const { extension, id } = useParams();

    const { t } = useTranslation();
    const { getValues } = useFormContext<TRelationshipGroupForm>();

    const { sendRequest } = useFetch(list4uBusAutomations);

    const [optionsUBusAutomation, setOptionsUBusAutomation] = useState<
      ISelectType[]
    >([]);

    const fetchUBusAutomation = useCallback(async () => {
      const { data, success } = await sendRequest({
        ExtensionCode: extension,
        OnlyWith4uBusRelationshipType: true,
      });

      if (data && success) {
        setOptionsUBusAutomation(
          data.map((d) => ({
            id: d.id,
            name: d.name,
            code: d.code.toString(),
          })),
        );
      }
    }, [extension, sendRequest]);

    useEffect(() => {
      fetchUBusAutomation();
    }, [fetchUBusAutomation]);

    if (id && disableEdit) {
      return (
        <Grid item xs={12} sm={6}>
          <FormInformation
            label={t(translationPath + "u_bus_automation")}
            data={getValues("uBusAutomation")?.name ?? ""}
            minHeight={40}
          />
        </Grid>
      );
    }

    return (
      <Grid item xs={12} sm={6}>
        <AutoComplete
          name="uBusAutomation"
          size="small"
          options={optionsUBusAutomation}
          getOptionLabel={(option) => option.name}
          label={t(translationPath + "u_bus_automation")}
          onValueChange={(item) => defineUBusAutomationCode(Number(item?.code))}
        />
      </Grid>
    );
  },
);
